/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { CollaspibleHeader } from "lib/CollaspibleHeader";
import { sidebarOptions } from "./sidebarOptions";
import { _t } from "app/i18n/i18n";
import useIsMobile from "../../../lib/hooks/useIsMobile";
import ErrorBoundary from "lib/ErrorBoundary";
import { AnalystSearchBox } from "../menu/AnalystSearchBox";
import { isPublicPath } from "lib/routing";
import { SidebarButton } from "./SidebarButton";

export function AnalystSidebar({ aggs = { region: [], speciality: [] } }) {
  const isMobile = useIsMobile(768);
  return !isMobile ? <AnalystSidebarDesktop aggs={aggs} /> : null;
}

function AnalystSidebarDesktop({ aggs }) {
  return (
    <ErrorBoundary>
      <section className="position-sticky" style={{ top: "20px" }}>
        <AnalystSearchBox />
        <CollaspibleHeader headerLabel={_t("Region")} headerCss={headCss} isVisible={!isPublicPath()} defaultOpen>
          {sidebarOptions.regions.map(SidebarButton(aggs))}
        </CollaspibleHeader>
        <CollaspibleHeader headerLabel={_t("Macro")} headerCss={headCss} defaultOpen>
          {sidebarOptions.Macro.map(SidebarButton(aggs))}
        </CollaspibleHeader>
        <CollaspibleHeader headerLabel={_t("Equity")} headerCss={headCss} defaultOpen>
          {sidebarOptions.Equity.map(SidebarButton(aggs))}
        </CollaspibleHeader>
      </section>
    </ErrorBoundary>
  );
}

const headCss = "mt-3 h5 cursor-pointer";
